<ng-container *transloco="let te; read 'events'">

  @if (events) {
    <div class="card-list">
      @for (event of events; track eventTrackBy(i, event); let i = $index) {
        <div
          class="card-list__card"
          [attr.data-cy]="'event-'+i"
          >
          <app-event-card [event]="event" [oldWidget]="oldWidget"/>
        </div>
      }
      @if (events && events.length === 0 && !isLoadingEvents) {
        <div class="card-list">
          @if (!eventsBrowseService.browseModel.searchQuery) {
            <p class="text m-auto mt-5 custom-element-on-background-color">
              {{ te('noEventAvailable') }}
            </p>
          } @else {
            <p class="text m-auto mt-5 custom-element-on-background-color">{{ te('noEventMatches') }}</p>
          }
        </div>
      }
      @if (isLoadingEvents) {
        <app-loader diameter="40" class="my-5 mx-auto"/>
      }
      @if (!isLoadingEvents && moreToLoad) {
        <div class="buttons-group --row --centered">
          @if (isBrowser) {
            <button
              mat-button
              class="button --xlarge --outlined-primary"
              [disabled]="!moreToLoad"
              (click)="loadMoreEvents()"
              >
              {{ te('loadMore') }}
            </button>
          } @else {
            <a
              mat-button
              class="button --xlarge --outlined-primary"
              [disabled]="!moreToLoad"
              [routerLink]="['.']"
              [queryParams]="{page: (offset / limit) + 1}"
              >
              {{ te('loadMore') }}
            </a>
          }
        </div>
      }
    </div>
  }

</ng-container>
